import '.fg{height:2rem;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.cz{justify-content:flex-end;}.ssr-plugin'
import '.bs{position:relative;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.ap{cursor:pointer;}.ssr-plugin'
import '.a8{width:100%;}.ssr-plugin'
import '.d8{position:sticky;}.ssr-plugin'
import '.cg{top:0;}.ssr-plugin'
import '.ge{z-index:8;}.ssr-plugin'
import '.cr{background:var(--shades-white);}.ssr-plugin'
import '.bp{padding:1rem;}.ssr-plugin'
import '.a9{justify-content:space-between;}.ssr-plugin'
import { useCallback, useState } from 'react'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Button } from '@app/components/core/button/Button'
import { styled } from 'inlines'
import fullLogo from '@app/assets/fullLogo.svg'
import { MegaMenu } from '../../megaMenu/MegaMenu.mobile'
import { faBars } from '@fortawesome/pro-regular-svg-icons'
import { useAuthModal } from '@app/util/hooks/useAuthModal'
import { pages } from '@app/util/links'
import { TextLink } from '@app/components/core/link/TextLink'
import { ProfileMenu } from '../blocks/ProfileMenu'
import { Image } from '@app/components/core/image/Image'
import { useTranslations } from '@i18n/useLanguage'

export type TopNavBarProps = {
  userName?: string
  avatar?: string
  isLoading?: boolean
}

const ACCOUNT_SLOT_WIDTH = '6rem'
const ACCOUNT_APPEAR_ANIMATION = 'nav-account-appear 220ms ease-out'

export const TopNavBar = ({
  userName,
  avatar,
  isLoading,
}: TopNavBarProps) => {
  const [navigationMenuOpen, setNavigationMenuOpen] = useState(false)
  const { showAuthModal } = useAuthModal()
  const translations = useTranslations().app.common
  const renderAccountSection = useCallback(() => {
    if (isLoading) {
      return (
        <div className="fg"
          style={{
            width: ACCOUNT_SLOT_WIDTH,}}
        />
      )
    }

    return userName ? (
      <div className="a cz"
        style={{
          width: ACCOUNT_SLOT_WIDTH,
          animation: ACCOUNT_APPEAR_ANIMATION,
        }}
      >
        <ProfileMenu>
          <div className="bs a e f ap"
          >
            <Avatar size="extra-small" labelSource={userName} image={avatar} />
          </div>
        </ProfileMenu>
      </div>
    ) : (
      <div className="a cz"
        style={{
          width: ACCOUNT_SLOT_WIDTH,
          animation: ACCOUNT_APPEAR_ANIMATION,
        }}
      >
        <Button
          variant="primary"
          label={translations.signUp}
          size="small"
          onClick={() => showAuthModal('signUp')}
        />
      </div>
    )
  }, [isLoading, userName, avatar, showAuthModal, translations.signUp])

  return (
    <div className="a8 d8 cg ge cr"
    >
      <nav className="cr a8 a bp a9 f"
      >
        <Button
          variant="link"
          icon={faBars}
          onClick={() => setNavigationMenuOpen(true)}
        />
        <TextLink to={pages.home} noHover={true} isBold={false} hasIcon={false}>
          <Image
            src={fullLogo}
            alt="Crowdbuilding Logo"
            resizeWidth={123}
            style={{
              width: 123,
            }}
          />
        </TextLink>
        {renderAccountSection()}
      </nav>
      <MegaMenu
        onClose={() => setNavigationMenuOpen(false)}
        isAuthenticated={userName !== undefined}
        isOpen={navigationMenuOpen}
      />
    </div>
  )
}
